import React from 'react'
import { AppBar, Toolbar, useMediaQuery, Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu'
import { useSelector } from 'react-redux'
import AppInfo from '../../components/AppInfo'
import clsx from 'clsx'
import { isNil, includes, isEmpty, find, prop } from 'ramda'
import { useTheme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton'

const useStyles = makeStyles((theme) => ({
  separator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider,
  },
  appBar: {
    backgroundColor: '#ffffff',
  },
}))

function ToolbarLayoutMain() {
  const classes = useStyles()

  //Responsive
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const navigation = useSelector(({ fuse }) => fuse.navigation)
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config)

  if (isEmpty(navigation)) {
    return null
  }
  const menuSelected = find(prop('isSelected'), navigation)

  const isShowAppInfo = includes(process.env['REACT_APP_ENV'], ['dev', 'qa'])

  return (
    <AppBar
      id="fuse-toolbar"
      elevation={2}
      className={clsx(classes.appBar, 'flex relative')}
    >
      <Toolbar className="p-0">
        {config.navbar.display && config.navbar.position === 'left' && (
          <>
            <Hidden lgUp>
              <NavbarMobileToggleButton className="w-64 h-64 p-0 text-black" />
            </Hidden>
            <Hidden mdDown>
              <div className="text-black mx-5 text-18 font-bold">
                {!isNil(menuSelected) && (
                  <FormattedMessage
                    id={
                      prop('headerId', menuSelected) ??
                      prop('localizedId', menuSelected)
                    }
                  />
                )}
              </div>
            </Hidden>
          </>
        )}
        <div className="flex flex-1 justify-end  ltr:pr-4 rtl:pl-4">
          <div className="flex">
            {!isDownXs && isShowAppInfo && <AppInfo />}
            <UserMenu />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  )
}

export default ToolbarLayoutMain
